<style lang="less" scoped>
.questionlist{display: flex;flex-direction: column;}
.fujian:hover{cursor: pointer;color:rgb(45, 137, 241);}
.el-pagination {text-align: center;}
.pagination{margin: 40px auto;}
.table {border-collapse: collapse;width: 100%;margin-top: 10px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr {width: 100%;height: 50px;}
.left{width: 200px;}
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;}
.btnbox .elbtn {margin-top: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr td .el-form-item /deep/.el-form-item__content {margin-right: 10px;}
.type /deep/ .el-input__inner {width: 200px;}
.content /deep/ .el-input__inner {width: 200px;}
.date-picker.el-input {width: 200px;}
.date-picker.el-input {width: 200px;}
.count /deep/ .el-input__inner {width: 50px;}
.fujian:hover{cursor: pointer;color:rgb(45, 137, 241);}
.pagination{margin-bottom: 40px;margin-top: 40px;}
</style>

<template>
  <div class="questionlist" id="questionlist">
    <!-- 搜素条件 -->
    <el-form ref="form" :model="form">
      <table>
          <tr class="tr">
            <td>
              <el-form-item>
                <div class="td td1">
                  <el-select clearable v-model="form.type" placeholder="请选择类型" class="type" disabled>
                    <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.key"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.content" clearable placeholder="请输入关键词" class="input content"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.user" clearable placeholder="请输入咨询人" class="input content"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button class="elbtn search" @click="search()">搜索</el-button>
                  <el-button class="elbtn reset" @click="cancelfnBtn()">重置</el-button>
                </div>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-form-item>
                <div class="td">
                  <el-date-picker v-model="form.starttime" type="datetime" placeholder="选择开始时间" class="date-picker">
                  </el-date-picker>
                  <span style="display: inline-block;width: 32px;text-align: center;">至</span>
                  <el-date-picker v-model="form.endtime" type="datetime" placeholder="选择结束时间" class="date-picker">
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td td1">
                  <el-select clearable v-model="form.iscomments" placeholder="请选择状态" class="type">
                    <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.key"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </td>
          </tr>
      </table>
    </el-form>
    <div class="el-tablebox">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; font-size: 15px;"
        @selection-change="handleSelectionChange"
        stripe
        border
        :cell-style="{textAlign: 'center', padding: '0'}"
        :header-cell-style="{background: '#F5F5F5', color: '#606266', textAlign: 'center',}">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="type" label="类型" width="100">
          <template slot-scope="scope">{{ scope.row.type | getClassification() }}</template>
        </el-table-column>
        <el-table-column prop="user" label="咨询人" width="80"> </el-table-column>
        <el-table-column prop="content" label="咨询内容" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="相关图片" width="180">
          <template slot-scope="scope">
            <p class="fujian" @click="look(scope.row.thumb)">查看附件</p>
            <el-dialog :visible.sync="isdialogVisible" width="30%" title="相关图片" class="mydialog">
              <img :src="urlShow" width="320px" height="280px" class="head_pic"/>
            </el-dialog>
          </template>
        </el-table-column>
        <el-table-column label="提问时间" width="180">
          <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
        </el-table-column>
        <el-table-column label="咨询状态" width="90">
          <template slot-scope="scope">{{ (scope.row.iscomments) | getComments() }}</template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="reply(scope.row)">回复</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 回复弹框 -->
    <el-dialog v-dialogDrag :visible.sync="dialogVisible" :width="widthCSH" title="咨询回复" class="mydialog">
      <LegalReply :rowid='rowid' @cancle="cancle" @getList="getList" v-if="dialogVisible"></LegalReply>
    </el-dialog>
    <!-- Page页 -->
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 李旭
 * 法律咨询列表页面
 */
import filters from '../../app/method/filter'
import LegalReply from '../../app/assembly/zxxx/FL/LegalReply.vue'
export default {
  mixins: [filters],
  components: {
    LegalReply
  },
  data()
  {
    return {
      form: {
        type: 2,
        content: '',
        user: '',
        starttime: '',
        endtime: '',
        iscomments: null,
        count: 20
      },
      // 类型下拉数据
      options1: [
        { value: '选项1', label: '咨询服务', key: 1 },
        { value: '选项2', label: '法律服务', key: 2 }
      ],
      // 类型下拉数据
      options2: [
        { value: '选项1', label: '未回复', key: 2 },
        { value: '选项2', label: '已回复', key: 1 }
      ],
      rowid: null,
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      // 查看附件图片弹框
      isdialogVisible: false,
      urlShow: '',
      //列表数据
      tableData: [],
      //弹框显隐
      dialogVisible: false,
      widthCSH: '75%'
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      let type = this.form.type
      let content = this.form.content
      let user = this.form.user
      let startTime = this.form.starttime.valueOf() / 1000
      let endTime = this.form.endtime.valueOf() / 1000
      let iscomments = this.form.iscomments
      let count = this.form.count
      let currentPage = this.currentPage
      let exp = ''
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'type')
          exp += `type = ${type} and `
        if (item && e === 'content')
          exp += `content like '%${content}%' and `
        if (item && e === 'user')
          exp += `user = ${user} and `
        if (item && e === 'starttime' && item.valueOf() / 1000 !== 0)
          exp += `addtime > ${startTime} and addtime < ${endTime} and `
        if (item && e === 'iscomments')
          exp += `iscomments = ${iscomments} and `
      }
      exp = exp ? `${exp}id != 0` : 'id>0'
      let paras = {cmd: 'query', _major: 11, _minor: 63, _exp: exp, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.tableData = []
        ret[0].data.forEach((item, index) =>
        {
          this.tableData.push({
            id: item.id,
            index: index + 1,
            content: item.content,
            thumb: item.thumb ? item.thumb : 'static/images/moren.jpg',
            addtime: item.addtime,
            user: item.user,
            type: item.type,
            iscomments: item.iscomments
          })
        })
      })
    },
    //查看附件
    look(str)
    {
      this.urlShow = str
      this.isdialogVisible = true
    },
    //点击回复
    reply(row)
    {
      this.rowid = row.id
      this.dialogVisible = true
    },
    //————列表页的公共方法————
    cancle()
    {
      this.dialogVisible = false
      this.getList()
    },
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/FlserverList.vue